import PermissionsScreen from "./PermissionsScreen";


export default PermissionsScreen;